export class FullAddress {
    countryCode: number;
    govCode: number;
    cityCode: number;
    villageCode: number;
    fullAddressAr: string;
    fullAddressEn: string;
    nationalityId: number;
    nationalityEn: string;
    nationalityAr: string;
    countryNameEn: string;
    countryNameAr: string;
    govNameEn: string;
    govNameAr: string;
    cityNameEn: string;
    cityNameAr: string;
    villageNameEn: string;
    villageNameAr: string;

    constructor(_countryCode?: number, _govCode?: number, _cityCode?: number,
        _villageCode?: number, _fullAddressAr?: string, _fullAddressEn?: string, _nationalityId?: number, _nationalityEn?: string,
        _nationalityAr?: string, _countryNameEn?: string, _countryNameAr?: string, _govNameEn?: string, _govNameAr?: string, _cityNameEn?: string, _cityNameAr?: string, _villageNameEn?: string, _villageNameAr?: string) {
        this.countryCode = _countryCode;
        this.govCode = _govCode;
        this.cityCode = _cityCode;
        this.villageCode = _villageCode;
        this.fullAddressAr = _fullAddressAr;
        this.fullAddressEn = _fullAddressEn;
        this.nationalityId = _nationalityId;
        this.nationalityEn = _nationalityEn;
        this.nationalityAr = _nationalityAr;
        this.countryNameEn = _countryNameEn;
        this.countryNameAr = _countryNameAr;
        this.govNameEn = _govNameEn;
        this.govNameAr = _govNameAr;
        this.cityNameEn = _cityNameEn;
        this.cityNameAr = _cityNameAr;
        this.villageNameAr = _villageNameAr;
        this.villageNameEn = _villageNameEn;
    }
}

